// Pure zoom/rotation math for the document viewer modal. Zoom is relative to
// "fit to width" (1 = the document exactly fills the viewer's width).

// Zoom limits and steps, in whole percent (integer math avoids 0.1 + 0.05
// drift). The large step is for Shift-click / Shift+key.
export const MIN_ZOOM_PERCENT = 50;
export const MAX_ZOOM_PERCENT = 400;
export const ZOOM_STEP_PERCENT = 5;
export const LARGE_ZOOM_STEP_PERCENT = 25;

// Zoom one `step` (percent) above (direction 1) or below (direction -1)
// `current`, landing on a multiple of the step and clamped to the limits.
export function stepZoom(current, direction, step = ZOOM_STEP_PERCENT) {
  const percent = Math.round(current * 100);
  const snapped =
    direction > 0
      ? Math.floor(percent / step) * step + step
      : Math.ceil(percent / step) * step - step;
  const clamped = Math.min(
    MAX_ZOOM_PERCENT,
    Math.max(MIN_ZOOM_PERCENT, snapped),
  );
  return clamped / 100;
}

// Rotation after turning `current` by `delta` degrees, normalized to 0/90/180/270.
export function turn(current, delta) {
  return (((current + delta) % 360) + 360) % 360;
}

// Width/height of a `width`×`height` box once rotated by `rotation` degrees.
export function rotatedSize(width, height, rotation) {
  return rotation % 180 === 0
    ? { width, height }
    : { width: height, height: width };
}

// Display scale for a document `docWidth` units wide (image pixels or PDF
// points, after rotation) so it spans `viewerWidth` CSS pixels at zoom 1.
export function fitScale(docWidth, viewerWidth, zoom) {
  if (!docWidth || !viewerWidth) return zoom;
  return (viewerWidth / docWidth) * zoom;
}
